/**
 * Test if a list of symbols are included in a single string and retuns the ones that are included
 * @category Getters
 * @category String
 */
export function getSymbolsIncluded(
  value: string | null | undefined,
  symbols: string[],
) {
  if (!value) {
    return [];
  }

  return symbols.reduce((includedSymbols, symbol) => {
    if (value.includes(symbol)) {
      return [...includedSymbols, symbol];
    }
    return includedSymbols;
  }, []);
}
